module.exports = __webpack_public_path__ + "img/wms.bcf67936.svg";